import styled, { keyframes } from 'styled-components/macro'
import { rem } from '../../utils/styles'
import Pane from '../Pane'

const modalEnter = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`

const ModalPane = styled(Pane)`
  position: relative;
  max-width: ${rem(640)};
  margin: 0 auto;
  padding-bottom: ${rem(20)};
  top: 10%;
  animation: ${modalEnter} 500ms cubic-bezier(0.18, 0.89, 0.32, 1.28);
`

export default ModalPane
